import React from "react"
import { componentStyles } from "@mallardbay/lib-react-components"

import type { MediaFieldsFragment } from "~graphql/generated/graphql"
import ActivityCard from "~components/shared/activity-card/activity-card"
import DrawerWithShareButton from "~components/shared/drawer-with-share-button"
import {
    clearUrlQueryParams,
    getActivityIdUrlQueryParam,
} from "~utils/url-param-helpers"
import { useStreamActivityById } from "~utils/stream-feeds"
import { useTrackNewsfeedPostOpenedEvent } from "~utils/event-hooks"
import LoadingOrErrorContainer from "~components/shared/todo-lib-react-components/loading-or-error-container"
import Box from "~components/shared/todo-lib-react-components/box"

interface Props {
    readonly avatar?: MediaFieldsFragment | null
    readonly title: string
}

export default function ActivityCardModal({ avatar, title }: Props) {
    const styles = useStyles()

    const activityId = getActivityIdUrlQueryParam()

    const { activity, isLoading, error } = useStreamActivityById(activityId)

    useTrackNewsfeedPostOpenedEvent(activity)

    return (
        <DrawerWithShareButton
            isOpen={!!activityId}
            onClose={clearUrlQueryParams}
        >
            <Box style={styles.main}>
                <LoadingOrErrorContainer
                    shouldRenderChildren={!!activity}
                    error={error}
                    isLoading={isLoading}
                >
                    {activity && (
                        <ActivityCard
                            activity={activity}
                            avatar={avatar}
                            title={title}
                            inModal
                        />
                    )}
                </LoadingOrErrorContainer>
            </Box>
        </DrawerWithShareButton>
    )
}

function useStyles() {
    return componentStyles({
        main: {
            width: "100%",
            maxWidth: "800px",
        },
    })
}
